import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './design/fonts.css'
import './design/tokens.css'
import { App } from './app/App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
